import { createSelector } from 'reselect';

import { selectCartItems } from './selectCartItems';

export const selectZeroQuantityCartItems = createSelector(
    [selectCartItems],
    (items) => items.filter(item => item.quantity === 0),
);
